import BasePreprocessor from './BasePreprocessor';

export default class AdvanceSearchPreprocessor extends BasePreprocessor {
	constructor() {
		super();
		this._conditions = this._createEmptyGroup();
		this._filters = [];
	}

	get conditions() {
		return this._conditions;
	}
	set conditions(newConditions) {
		if (newConditions && typeof newConditions === 'object') {
			this._conditions = Object.assign(this._createEmptyGroup(), newConditions);
		} else {
			this._conditions = this._createEmptyGroup();
		}

		if (this.executor.preprocessors.pagingPreprocessor) {
			this.executor.preprocessors.pagingPreprocessor.page = 0;
		}

		this.changed();
	}

	get filters() {
		return this._filters;
	}
	set filters(newFilters) {
		if (Array.isArray(newFilters) && newFilters.every((filter) => typeof filter === 'string')) {
			this._filters = newFilters;
			this.changed();
		}
	}

	_createEmptyGroup() {
		return {
			Conditions: [],
			Groups: [],
			LogicalOperator: mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND,
		};
	}

	init(executor) {
		this.executor = executor;
		this.enabled = Boolean(executor.dataQuery && executor.dataQuery.Id);
	}
}
